import Model from '@/models/Model'

export default class GState extends Model {
    resource() {
        return 'g_state'
    }
}